module.exports = __webpack_public_path__ + "img/6.75087d65.svg";